export default __webpack_public_path__ + "static/media/PURILUX.f9fc90d4.png";